export default "__VITE_ASSET__59da13b3__"